import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useTheme } from '../../contexts/ThemeContext';
import { CONTENT_FONT_FAMILY } from '../../utils/fonts';

interface MarkdownTextProps {
  children: string;
  fontSize?: number;
  style?: React.CSSProperties;
  className?: string;
}

export const MarkdownText: React.FC<MarkdownTextProps> = ({
  children,
  fontSize = 16,
  style,
  className,
}) => {
  const { theme } = useTheme();

  const markdownComponents = {
    p: ({ children }: any) => (
      <p
        style={{
          marginBottom: '16px',
          lineHeight: `${fontSize * 1.6}px`,
          color: theme.colors.text,
          fontFamily: CONTENT_FONT_FAMILY,
          fontSize: `${fontSize}px`,
        }}
      >
        {children}
      </p>
    ),
    h1: ({ children }: any) => (
      <h1
        style={{
          marginBottom: '20px',
          lineHeight: `${fontSize * 1.4}px`,
          color: theme.colors.text,
          fontFamily: CONTENT_FONT_FAMILY,
          fontSize: `${fontSize * 1.8}px`,
        }}
      >
        {children}
      </h1>
    ),
    h2: ({ children }: any) => (
      <h2
        style={{
          marginBottom: '16px',
          lineHeight: `${fontSize * 1.4}px`,
          color: theme.colors.text,
          fontFamily: CONTENT_FONT_FAMILY,
          fontSize: `${fontSize * 1.5}px`,
        }}
      >
        {children}
      </h2>
    ),
    h3: ({ children }: any) => (
      <h3
        style={{
          marginBottom: '12px',
          lineHeight: `${fontSize * 1.4}px`,
          color: theme.colors.text,
          fontFamily: CONTENT_FONT_FAMILY,
          fontSize: `${fontSize * 1.3}px`,
        }}
      >
        {children}
      </h3>
    ),
    em: ({ children }: any) => (
      <em
        style={{
          fontStyle: 'italic',
          color: theme.colors.text,
        }}
      >
        {children}
      </em>
    ),
    strong: ({ children }: any) => (
      <strong
        style={{
          fontWeight: 'bold',
          color: theme.colors.text,
        }}
      >
        {children}
      </strong>
    ),
  };

  const containerStyles: React.CSSProperties = {
    color: theme.colors.text,
    fontFamily: CONTENT_FONT_FAMILY,
    fontSize: `${fontSize}px`,
    lineHeight: `${fontSize * 1.6}px`,
    ...style,
  };

  return (
    <div style={containerStyles} className={className}>
      <ReactMarkdown components={markdownComponents}>{children}</ReactMarkdown>
    </div>
  );
};
